import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
export default () => ({
    id_tab: 1,
    phone: null,
    slider(start = 1000, min = 10, max = 2000, step = 10) {
        noUiSlider.create(this.$refs.slider, {
            start: [start],
            step: step,
            tooltips: [
                {
                    to: function (value) {
                        document.getElementById('budget_tariff').value = Number(value).toFixed(0);
                        return number_format(Number(value).toFixed(0), 0, '', ' ') + ' ₽';
                    }
                }
            ],
            range: {
                'min': [min],
                'max': [max]
            }
        });
    },
    init() {
        document.body.addEventListener('htmx:afterSwap', (event) => {
            if (event.target && event.target.id === 'setting_tariff_modern_inputs') {
                const sections = document.querySelectorAll(".setting_tariff_modern");
                sections.forEach((section) => {
                    const btn = section.querySelector('.setting_tariff__send');
                    if (btn) {
                        const span = btn.querySelector('span');
                        if (span) {
                            span.textContent = 'Отправлено';
                        }
                    }
                    setTimeout(() => {
                        this.id_tab = 1;
                        if (btn) {
                            const span = btn.querySelector('span');
                            if (span) {
                                span.textContent = 'Отправить заявку';
                            }
                        }
                    }, 300);
                })
            }
        });
    },
    btn_next() {
        if (this.id_tab < 6)
            this.id_tab++;
    },
    btn_prev() {
        if (this.id_tab > 1)
            this.id_tab--;
    },
    // get btn_rent() {
    //     let classes = {};
    //     if( this.phone == '' || !(/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(this.phone)) )
    //         classes['disabled'] = true;
    //     return classes;
    // },
    paginate(id) {
        return this.id_tab === id ? 'active' :
            id > this.id_tab ? 'next' :
                id < this.id_tab ? 'prev' : '';
    }
})